import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { characters } from "@/mocks/siteData";

export default function Characters() {
  return (
    <section id="characters" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="人物小传"
            title="认识故事里的几个人"
            description="主要人物不多，但每个人都带着自己的生活逻辑。先把人认清楚，再看剧情会顺畅很多。"
          />
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {characters.map((person, index) => (
            <Reveal key={person.id} delay={index * 80}>
              <article className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="h-56 w-full bg-background-100">
                  <img src={person.image} alt={`${person.role}的人物形象示意`} className="h-full w-full object-top" />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{person.role}</h3>
                  <p className="mt-2 inline-flex w-fit rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-800">
                    {person.trait}
                  </p>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{person.detail}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}